import api from "../api";

/**
 * Force reset password after SMS verification
 * API #5: POST /app/auth/force-reset-password
 * Note: This should be called AFTER verifySmsCode has been called to establish the session
 * @param {string} newPassword - New password
 * @param {{ token?: string }=} options - Optional request options
 * @returns {Promise<object>} Response data on success
 */
const sendPasswordReset = async (newPassword, options = {}) => {
  const requestData = {
    newPassword: newPassword,
  };

  try {
    const requestOptions =
      options && typeof options === "object" && options.token
        ? { headers: { Authorization: `Bearer ${options.token}` } }
        : undefined;

    const response = await api.post(
      process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT + "/app/auth/force-reset-password",
      requestData,
      requestOptions
    );

    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      console.error("Password reset failed with status:", response.status);
      return null;
    }
  } catch (error) {
    console.error("There was a problem with the password reset:", error);
    throw error;
  }
};

export default sendPasswordReset;
